import { namedStateMapProvider } from "./namedState";

let countLogOutput = 0;

export const productState = namedStateMapProvider( 'productsStore', 'products' );